import { useTranslation } from 'react-i18next';
import { useNotification } from '@starjack/features/notifications';

/** Copies text and confirms it with a toast; shared by every copy button here. */
export const useCopyToClipboard = () => {
    const { t } = useTranslation();
    const { addNotification } = useNotification();

    return async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            addNotification({
                type: 'success',
                message: t('copiedToClipboard'),
            });
        } catch (err) {
            console.error('Failed to copy to clipboard:', err);
            addNotification({
                type: 'error',
                message: 'Failed to copy to clipboard',
            });
        }
    };
};
